export const Topics = {
  state: () => ({
    data: []
  })
}
